import React, { Component } from 'react';
import { availableCartIconStyles, availableSpinnerIconStyles, availableIconStyles } from '../../../../assets/creator/icons';
import IconStyleOption from './IconStyleOption/IconStyleOption';
import CartIconStyleDropdown from './CartIconStyleDropdown/CartIconStyleDropdown';
import { getTranslation } from '../../../../assets/creator/translations';

class StyleMenuIcons extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedElement: null
        };
    }

    render = () => (
        <React.Fragment>
			  <div className="style-menu__icon-section-title">{getTranslation("Sty_ChangeIconStyle")}</div>
        {mapIconStylesToOptions(this.props.onIconStyleSelect, this.props.currentIconStyle)}

        <div className="style-menu__icon-section-title">{getTranslation("Sty_ChangeIconType")}</div>
        { availableCartIconStyles[0] === "shopping-cart" && 
        <CartIconStyleDropdown
            title="basket icon"
            icon="shopping-cart"
            iconArray={availableCartIconStyles}
            folder="cartIconStyle"
            onIconStyleSelect={this.props.onCartIconStyleSelect}
            onCartIconStyleSelect={this.props.onCartIconStyleSelect}
            currentIconStyle={this.props.currentIconStyle}
            currentCartIconStyle={this.props.currentCartIconStyle}
           
        /> 
        } 
        {/* <div className="style-menu__icon-section-title">{getTranslation("")}</div> */}
        <div className="style-menu__icon-section-title">Zmień rodzaj loadera</div>

            { availableSpinnerIconStyles[0] === "spinner-third" && <CartIconStyleDropdown
                title="loader"
                icon="slider"
                iconArray={availableSpinnerIconStyles}
                folder="spinnerIconStyle"
                isSelected={"slider"===this.state.selectedElement}
                onIconStyleSelect={this.props.onSpinnerIconStyleSelect}
                onCartIconStyleSelect={this.props.onSpinnerIconStyleSelect}
                currentIconStyle={this.props.currentIconStyle}
                currentCartIconStyle={this.props.currentSpinnerIconStyle}
            /> }
		</React.Fragment>
    )
}
export default StyleMenuIcons;

const mapIconStylesToOptions = (onIconStyleSelect, currentIconStyle) => (
    availableIconStyles.map((item, index) => (
        <IconStyleOption
            key={index}
            iconStyle={item}
            onSelect={onIconStyleSelect}
            isCurrentIcon={item === currentIconStyle}
            currentIcon={currentIconStyle}
        />
    ))
)